import { useCreateEntityElement } from 'publisher/context/create-entity-element-context'
import { usePage, useWebsiteSettings } from 'publisher/store'
import { getChildrenEntities } from 'publisher/store/page/pageSelectors'
import React, { memo } from 'react'
import { getWebsiteThemeBackground } from 'src/publisher/store/website-settings/website-settings-selector'
import { CommonWebsiteLayoutBody } from 'src/shared/entities/website-layout-body'
import { WebsiteLayoutBodyInterface } from 'src/shared/types/website-entities'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'

export interface WebsiteLayoutBodyProps {
  entity: WebsiteLayoutBodyInterface
}

export const WebsiteLayoutBody = memo(({ entity }: WebsiteLayoutBodyProps) => {
  const createEntityElement = useCreateEntityElement()
  const layoutEntities = usePage(page =>
    getChildrenEntities(page, entity.childIds),
  )

  const header = createEntityElement(layoutEntities[0])
  const footer = createEntityElement(layoutEntities[1])
  const content = createEntityElement(layoutEntities[2])

  const background = useWebsiteSettings(getWebsiteThemeBackground)
  const backgroundImage = getBackgroundImageStyleValue(
    background?.pageBackgroundPicture?.file,
  )

  return (
    <CommonWebsiteLayoutBody
      header={header}
      content={content}
      footer={footer}
      backgroundImage={backgroundImage}
      background={background?.pageBackgroundColor}
    />
  )
})
